import React, { FC } from 'react';

type PaginationProps = {
  label: string;
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

// Replaces Polaris React's Pagination: previous/next buttons around a label.
const Pagination: FC<PaginationProps> = ({ label, hasPrevious, hasNext, onPrevious, onNext }) => (
  <nav aria-label='Pagination'>
    <s-stack direction='inline' gap='small-200' alignItems='center'>
      <s-button icon='chevron-left' accessibilityLabel='Previous' disabled={!hasPrevious} onClick={onPrevious} />
      <s-text>{label}</s-text>
      <s-button icon='chevron-right' accessibilityLabel='Next' disabled={!hasNext} onClick={onNext} />
    </s-stack>
  </nav>
);

export default Pagination;
